import {userRoutes} from '../../router/index'
const user={
  namespaced: true,
  state: {
    user_menu_list:{},
    token:''
  },
  getters: {
    getUserName(state) {
      return state.user_menu_list.mail
    },
    getMenu(state) {
      return state.user_menu_list.menuList
    },
    getToken(state){
      return state.token
    }
  },  
  mutations: {
    SET_USER_INFO(state, payload) {
      state.user_menu_list = payload.userInfo
      state.token=payload.token
    },
    LOG_OUT(state){
      state.user_menu_list = {}
      state.token=''
      localStorage.removeItem('user_info')
    }
  },
  actions: {
    updateUserInfo({ getters,commit }, payload=null) {
      const store=JSON.parse(localStorage.getItem('user_info'))||{}
      if (!payload&&!store.token){
        const token = getters.getToken;
        if (!token){
          window.localStorage.href='/#/login'
          return
        }
      }else{
        if (payload){
          commit('SET_USER_INFO',payload)
          localStorage.setItem('user_info',JSON.stringify(payload))
        }else{
          commit('SET_USER_INFO',store)
        }
      }
      userRoutes(getters.getMenu)
    },
  },
}

export default user